import CustomizationService from './CustomizationService';
// [CurveBeamAI-PATCH] Required for setCustomizations(..., CustomizationScope.Global) in app bootstrap
import { CustomizationScope } from './CustomizationService';

export { GENERAL_MODE_KEY, normalizeCustomizationConfig } from './CustomizationService';
export type {
  CustomizationModule,
  CustomizationPhaseInput,
  ModePhaseCustomizations,
  PhasedCustomizationConfig,
} from './customizationUrlTypes';

export default CustomizationService;
// [CurveBeamAI-PATCH] Re-export for app bootstrap
export { CustomizationScope };
